import React, { useEffect } from 'react';
import css from './FaqPage.module.css';
import { useIntl } from 'react-intl';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import FaqSection from './FaqSection/FaqSection';
import { useDispatch } from 'react-redux';
import { fetchAllFaqs } from '../../ducks/strapi.duck';

const FaqPage = props => {
  const intl = useIntl();
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(fetchAllFaqs());
  }, []);

  return (
    <Page title={intl.formatMessage({ id: 'FaqPage.title' })} scrollingDisabled={false}>
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        topbar={<TopbarContainer currentPage="FaqPage" type="floating" />}
        footer={<FooterContainer />}
      >
        <center className={css.mainTitle}>
          <h2>{intl.formatMessage({ id: 'FaqPage.mainTitle' })}</h2>
        </center>

        <FaqSection />
      </LayoutSingleColumn>
    </Page>
  );
};

export default FaqPage;
